// extracted by mini-css-extract-plugin
export default {"input":"CodeContent_input__+uLnl"};